var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 26.3333C12.4666 26.3333 13.6666 25.1333 13.6666 23.6667H8.33331C8.33331 24.3739 8.61426 25.0522 9.11436 25.5523C9.61446 26.0524 10.2927 26.3333 11 26.3333ZM19 18.3333V11.6667C19 7.57334 16.8133 4.14668 13 3.24001V2.33334C13 1.22668 12.1066 0.333344 11 0.333344C9.89331 0.333344 8.99998 1.22668 8.99998 2.33334V3.24001C5.17331 4.14668 2.99998 7.56001 2.99998 11.6667V18.3333L0.333313 21V22.3333H21.6666V21L19 18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d8b157def4bfc7763639836a8d450b79.svg";
export { ForwardRef as ReactComponent };